(function () {
  // Helper: fetch cart details
  function fetchCartDetails() {
    return fetch('/cart.js').then((res) => res.json());
  }

  // Helper: fix image URL
  function cleanImageUrl(imageUrl) {
    if (!imageUrl) return '';
    if (imageUrl.startsWith('//')) {
      return 'https:' + imageUrl;
    } else if (imageUrl.startsWith('http')) {
      return imageUrl;
    } else {
      return 'https://' + imageUrl;
    }
  }

  // Helper: transform product object to match payload structure
  function transformProduct(item) {
    const imageUrl = item.featured_image
      ? (item.featured_image.url
          ? cleanImageUrl(item.featured_image.url)
          : cleanImageUrl(item.featured_image))
      : '';

    return {
      Url: window.location.origin + item.url,
      Name: item.product_title,
      Brand: item.vendor,
      Price: (item.price / 100).toFixed(2),
      Variant: item.variant_title,
      Currency: 'USD',
      ImageUrl: imageUrl,
      ProductId: item.product_id.toString(),
      VariantId: item.variant_id.toString(),
      Quantity: item.quantity
    };
  }

  // Helper: build payload
  function buildPayload(product, cart) {
    let imageUrl = '';
    if (product.featured_image) {
      imageUrl = cleanImageUrl(product.featured_image);
    }
    return {
      Url: window.location.href,
      Name: product.title,
      Brand: product.vendor,
      Price: (product.price / 100).toFixed(2),
      Variant: product.variant_title,
      Currency: 'USD',
      ImageUrl: imageUrl,
      ProductId: product.id.toString(),
      VariantId: product.variant_id ? product.variant_id.toString() : '',
      Quantity: 1,
      CartUrl: window.location.origin + '/cart',
      products: cart.items.map(transformProduct),
    };
  }

  // Helper: extract product data from modal form if available
  function extractProductFromModal(button) {
    const form = button.closest('form');
    if (form && form.dataset && form.dataset.product) {
      try {
        const productData = JSON.parse(form.dataset.product);
        const variantSelect = form.querySelector('select[name="id"]');
        const variantId = variantSelect ? variantSelect.value : null;
        const variant = productData.variants.find(v => v.id.toString() === variantId) ||
                        productData.variants[0];
        productData.variant_id = variant.id;
        productData.variant_title = variant.title;
        productData.price = variant.price;
        return productData;
      } catch (e) {
        console.error('[Retention ATC] Error parsing modal product data:', e);
      }
    }
    return null;
  }

  // Helper: fetch product details from endpoint
  function fetchProductDetails(productId) {
    return fetch(`/products/${productId}.js`).then((res) => res.json());
  }

  // Helper: wait for the specific product to appear in the cart
  function waitForProductInCart(productId, retries = 5, interval = 1000) {
    return new Promise((resolve, reject) => {
      let attempts = 0;
      function checkCart() {
        fetchCartDetails().then(cart => {
          const itemInCart = cart.items.find(item => item.product_id.toString() === productId.toString());
          if (itemInCart) {
            resolve(cart);
          } else if (attempts < retries) {
            attempts++;
            setTimeout(checkCart, interval);
          } else {
            console.warn('[Retention ATC] Product not found in cart after retries; proceeding anyway.');
            resolve(cart); // fallback even if product is missing
          }
        }).catch(reject);
      }
      checkCart();
    });
  }

  // Main handler for Add to Cart click
  function handleAddToCartClick(e) {
    const button = e.target.closest('.add_to_cart, [name="add"][data-label="Add to Cart"], [data-narvar-button="addtocart"]');
    if (!button) return;

    let product = extractProductFromModal(button);
    let productPromise;

    if (product) {
      productPromise = Promise.resolve(product);
    } else {
      let productId = window.location.pathname.split('/products/')[1];
      if (productId && productId.includes('?')) {
        productId = productId.split('?')[0];
      }
      if (!productId) {
        console.error('[Retention ATC] Product ID not found in URL.');
        return;
      }
      console.log('[Retention ATC] Fetching product details from page for productId:', productId);
      productPromise = fetchProductDetails(productId);
    }

    productPromise
      .then((productData) => {
        waitForProductInCart(productData.id, 5, 1000)
          .then((cart) => {
            const payload = buildPayload(productData, cart);
            console.log('[Retention ATC] Final Payload:', payload);

            if (typeof geq !== 'undefined' && typeof geq.addToCart === 'function') {
              geq.addToCart(payload);
            }
          })
          .catch((error) => {
            console.error('[Retention ATC] Error waiting for product in cart:', error);
          });
      })
      .catch((error) => {
        console.error('[Retention ATC] Error fetching product details:', error);
      });
  }

  // Initialize click listeners on Add to Cart buttons
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.add_to_cart, [name="add"][data-label="Add to Cart"], [data-narvar-button="addtocart"]');
    if (button) {
      handleAddToCartClick(e);
    }
  });

  console.log('[Retention ATC] Add to Cart tracking script loaded.');
})();
